/* eslint-disable no-undef */
import { openFile,downloadFile } from './lib/openFile'
import { openMedia } from './lib/openMedia'
import { previewImage } from './lib/previewImage'

const install = function (Vue, opts = {}) {
  //文件配置
  if (opts.filePreviewUrl) {
    SmartFile.filePreviewUrl = opts.filePreviewUrl;
  }
};

const SmartFile = {
  width: "1000px",
  height: "500px",
  filePreviewUrl: "https://fileview.xddkj.cn/onlinePreview?url={url}",
  install,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  openFile,
  downloadFile,
  openMedia,
  previewImage,
};


export default SmartFile;
